import React from "react";
import { Box, Typography, Button, Card, CardContent, CardActions, Chip, IconButton, Divider } from "@mui/material";
import { Chat, Person } from "@mui/icons-material";

const PublicationCards = ({ publication, onViewChat, searchValue }) => {
    const searchLower = searchValue?.toLowerCase() || "";
    const chatNameLower = publication?.chatName?.toLowerCase() || "";

    if (!chatNameLower.includes(searchLower)) {
        return null;
    }

    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
                height: '180px',
                width: '100%',
                position: "relative",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    border: "1px solid #928F8F",
                },
            }}
        >
            <CardContent sx={{ padding: 2 }}>
                <Typography
                    variant="h3"
                    sx={{ fontWeight: 600, color: "#4527a0", textAlign: "left", textTransform: "capitalize" }}
                >
                    {publication.chatName}
                </Typography>


                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2, // Limits text to 2 lines
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                        marginTop: 1,
                        textAlign: "left",
                    }}
                    title={publication?.description} // Full text on hover
                >
                    {publication?.description}
                </Typography>

                {/* Tags Section */}
                {publication?.tags && (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, marginTop: 1.5 }}>

                        {Array.isArray(publication.tags) ? (
                            publication.tags.map((tag, index) => (
                                <Chip
                                    key={index}
                                    label={tag}
                                    size="small"
                                    variant="outlined"
                                />
                            ))
                        ) : (
                            <Chip
                                label={publication.tags}
                                size="small"
                                variant="outlined"
                            />
                        )}
                    </Box>
                )}

            </CardContent>
            <Divider orientation="horizontal" />

            <CardActions sx={{ display: "flex", justifyContent: "space-between", padding: 1 }}>
                {publication?.username && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, maxWidth: "50%", overflow: "hidden", justifyContent: "center" }}>
                        <Person sx={{ color: "#4527a0", fontSize: "1rem" }} />
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 500,
                                color: "#4527a0",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%", // Restricts text to half of the width
                            }}
                            title={publication.username} // Shows full name on hover
                        >
                            {publication.username}
                        </Typography>
                    </Box>
                )}

                <Button
                    onClick={() => onViewChat(publication)}
                    size="small"
                    variant="outlined"
                    sx={{
                        color: "#99cc33",
                        border: "1px solid #99cc33",
                        fontSize: "0.8rem",
                        padding: "4px 10px",
                        textTransform: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        "&:hover": {
                            backgroundColor: "rgba(153, 204, 51, 0.1)",
                        },
                    }}
                >
                    <Chat fontSize="small" />
                    View Chat
                </Button>
            </CardActions>

        </Card>
    );
};

export default PublicationCards;
